/**
 * Created by Ning Jiang on 6/28/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {IScreenConfig, ScreenController} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TimelineLite} from "gsap";
import {FruitsGameModuleConfig} from "../../../FruitsGameModuleConfig";
import {FruitsGameMode} from "../../../gamemode/FruitsGameMode";
import {FruitsReelController} from "../../../reel/reel/FruitsReelController";
import {FruitsReels} from "../../../reel/reelarea/FruitsReels";
import {FruitsParsedGameData} from "../../../server/data/FruitsParsedGameData";
import {FruitsHelper} from "../../../utils/FruitsHelper";
import {FruitsBonusGameController} from "../../FruitsBonusGameController";
import {FruitsStickyRespinOverlayView} from "../../respin/FruitsStickyRespinOverlayView";

export class BonusGameOutroController extends ScreenController {

    private delay:number = 1;

    constructor(config:IScreenConfig) {
        super("BonusGameOutro", config, true);
    }

    protected calculateIsTriggered(data:FruitsParsedGameData):boolean {
        return data.mode === FruitsGameMode.BONUS_GAME && data.bonusSpinsLeft === 0;
    }

    public start():void {
        EventHandler.dispatchEvent(new GameEvent(FruitsStickyRespinOverlayView.REMOVE_STICKY_SYMBOLS));
        super.start();
    }

    protected show():boolean {
        super.show();
        EventHandler.dispatchEvent(new GameEvent(FruitsBonusGameController.RESTORE_REELSET_TO_BEFORE_LAST_BONUS));
        FruitsGameModuleConfig.bonusOverlayView.showIndicatorOnScreenView();
        return true;
    }

    protected doTransitions():void {
        // Tell the reelArea to change the reel indexes, and symbols, and next reelsets, balabala...
        SlotGame.keypad.setZeroBetSpinCounter(-1);
        EventHandler.dispatchEvent(new GameEvent(FruitsReels.SET_FAKE_REELSET));
        EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {
            newMode : this._serverData!.nextMode,
            animate : true,
            showIntro : false
        }));
    }

    protected onCloseComplete():void {
        const tl:TimelineLite = new TimelineLite();
        EventHandler.dispatchEvent(new GameEvent(FruitsReelController.UPDATE_SCATTER_LEVEL, FruitsHelper.determineScatterLevel(1)));

        tl.add(FruitsGameModuleConfig.preOutroScreenViewBit.fadeOutBackground());
        tl.add(() => {
            super.onCloseComplete();
        });
    }


}